function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
}

function numberToLetter(number) {
    var result = '';
    var n = number;
    while (n >= 0) {
        result = String.fromCharCode(65 + (n % 26)) + result;
        n = Math.floor(n / 26) - 1;
        if (n < 0) break;
    }
    return result;
}

function letterToNumber(letter) {
    if (!letter || typeof letter !== 'string') return 0;
    var s = letter.toUpperCase();
    var result = 0;
    for (var i = 0; i < s.length; i++) {
        var code = s.charCodeAt(i) - 64;
        if (code < 1 || code > 26) return 0;
        result = result * 26 + code;
    }
    return Math.max(0, result - 1);
}

function clampGridPoint(gridX, gridY, gridWidth, gridHeight) {
    return {
        x: clamp(gridX, 0, Math.max(0, gridWidth - 1)),
        y: clamp(gridY, 0, Math.max(0, gridHeight - 1))
    };
}

function getGridIndicesFromTopLeftUnclamped(left, top, headerCellSize, boxSize) {
    return {
        x: Math.round((left - headerCellSize) / boxSize),
        y: Math.round((top - headerCellSize) / boxSize)
    };
}

function getGridPointFromTopLeft(left, top, headerCellSize, boxSize, gridWidth, gridHeight) {
    var raw = getGridIndicesFromTopLeftUnclamped(left, top, headerCellSize, boxSize);
    return clampGridPoint(raw.x, raw.y, gridWidth, gridHeight);
}

function getSeatGridPointFromObject(obj, fallbackConfig, gridPointResolver) {
    if (typeof gridPointResolver === 'function') {
        var width = (obj.width * (obj.scaleX || 1)) || fallbackConfig.boxSize;
        var height = (obj.height * (obj.scaleY || 1)) || width;
        var resolved = gridPointResolver(obj.left, obj.top, width, height);
        if (resolved && typeof resolved.gridX === 'number' && typeof resolved.gridY === 'number') {
            return { x: resolved.gridX, y: resolved.gridY };
        }
    }

    return getGridPointFromTopLeft(
        obj.left,
        obj.top,
        fallbackConfig.headerCellSize,
        fallbackConfig.boxSize,
        fallbackConfig.gridWidth,
        fallbackConfig.gridHeight
    );
}

function seatGridPointResolverFromBrowser() {
    if (typeof window === 'undefined') {
        return null;
    }
    if (typeof window.getGridCoordinatesFromPixel !== 'function') {
        return null;
    }
    var gp = window.gridPositioning;
    if (!gp || !gp.boxSize) {
        return null;
    }
    return function (left, top, width, height) {
        return window.getGridCoordinatesFromPixel(left, top, width, height);
    };
}

function getGridCellTopLeft(x, y, headerCellSize, boxSize) {
    return {
        left: headerCellSize + (x * boxSize),
        top: headerCellSize + (y * boxSize)
    };
}

function getGridPositionStringFromPixelTopLeft(x, y, headerCellSize, boxSize, gridWidth, gridHeight) {
    var point = getGridPointFromTopLeft(x, y, headerCellSize, boxSize, gridWidth, gridHeight);
    return numberToLetter(point.y) + (point.x + 1);
}

var SEAT_CELL_MARGIN = 2;
var FURNITURE_CELL_MARGIN = 3;

function getGridCellIndicesFromCenter(centerX, centerY, headerCellSize, boxSize, gridWidth, gridHeight) {
    var gridX = Math.round((centerX - headerCellSize - boxSize / 2) / boxSize);
    var gridY = Math.round((centerY - headerCellSize - boxSize / 2) / boxSize);
    var maxX = Math.max(0, gridWidth - 1);
    var maxY = Math.max(0, gridHeight - 1);
    return {
        gridX: clamp(gridX, 0, maxX),
        gridY: clamp(gridY, 0, maxY)
    };
}

function computeSeatSnapPixels(targetLeft, targetTop, w, h, headerCellSize, boxSize, gridWidth, gridHeight) {
    var effW = w || boxSize;
    var effH = h || effW;
    var centerX = targetLeft + effW / 2;
    var centerY = targetTop + effH / 2;
    var idx = getGridCellIndicesFromCenter(centerX, centerY, headerCellSize, boxSize, gridWidth, gridHeight);
    var seatRadius = Math.max(1, (boxSize / 2) - SEAT_CELL_MARGIN);
    var cellCenterX = headerCellSize + (idx.gridX * boxSize) + (boxSize / 2);
    var cellCenterY = headerCellSize + (idx.gridY * boxSize) + (boxSize / 2);
    return {
        left: cellCenterX - seatRadius,
        top: cellCenterY - seatRadius,
        radius: seatRadius
    };
}

function computeFurnitureSnapLayout(targetLeft, targetTop, targetWidth, targetHeight, headerCellSize, boxSize, gridWidth, gridHeight) {
    var rawTopLeft = getGridIndicesFromTopLeftUnclamped(targetLeft, targetTop, headerCellSize, boxSize);
    var gridX = rawTopLeft.x;
    var gridY = rawTopLeft.y;
    gridX = clamp(gridX, 0, Math.max(0, gridWidth - 1));
    gridY = clamp(gridY, 0, Math.max(0, gridHeight - 1));

    var snappedLeft = headerCellSize + (gridX * boxSize) + FURNITURE_CELL_MARGIN / 2;
    var snappedTop = headerCellSize + (gridY * boxSize) + FURNITURE_CELL_MARGIN / 2;

    var widthCells = Math.max(1, Math.round(targetWidth / boxSize));
    var heightCells = Math.max(1, Math.round(targetHeight / boxSize));

    if (gridX + widthCells > gridWidth) {
        gridX = gridWidth - widthCells;
        if (gridX < 0) {
            gridX = 0;
        }
    }
    if (gridY + heightCells > gridHeight) {
        gridY = gridHeight - heightCells;
        if (gridY < 0) {
            gridY = 0;
        }
    }

    var snappedWidth = (widthCells * boxSize) - FURNITURE_CELL_MARGIN;
    var snappedHeight = (heightCells * boxSize) - FURNITURE_CELL_MARGIN;

    if (snappedWidth < boxSize - FURNITURE_CELL_MARGIN) {
        snappedWidth = boxSize - FURNITURE_CELL_MARGIN;
    }
    if (snappedHeight < boxSize - FURNITURE_CELL_MARGIN) {
        snappedHeight = boxSize - FURNITURE_CELL_MARGIN;
    }

    return {
        left: snappedLeft,
        top: snappedTop,
        width: snappedWidth,
        height: snappedHeight,
        gridX: gridX,
        gridY: gridY,
        widthCells: widthCells,
        heightCells: heightCells
    };
}

function pixelRectToGridRange(left, top, width, height, headerCellSize, boxSize, gridWidth, gridHeight) {
    var startX = Math.round((left - headerCellSize) / boxSize);
    var startY = Math.round((top - headerCellSize) / boxSize);
    var endX = Math.round((left + width - headerCellSize) / boxSize);
    var endY = Math.round((top + height - headerCellSize) / boxSize);
    var clampedStartX = Math.max(0, startX);
    var clampedStartY = Math.max(0, startY);
    var maxX = Math.max(0, gridWidth - 1);
    var maxY = Math.max(0, gridHeight - 1);
    var clampedEndX = Math.max(clampedStartX, Math.min(endX, maxX));
    var clampedEndY = Math.max(clampedStartY, Math.min(endY, maxY));
    return {
        start_x: clampedStartX,
        start_y: clampedStartY,
        end_x: clampedEndX,
        end_y: clampedEndY
    };
}

function getGridRangeFromObjectRect(obj, headerCellSize, boxSize, rowLabeler) {
    var width = (obj.width || 0) * (obj.scaleX || 1);
    var height = (obj.height || 0) * (obj.scaleY || 1);

    var startX = Math.max(0, Math.round((obj.left - headerCellSize) / boxSize));
    var startY = Math.max(0, Math.round((obj.top - headerCellSize) / boxSize));
    var endX = Math.max(startX, Math.round((obj.left + width - headerCellSize) / boxSize));
    var endY = Math.max(startY, Math.round((obj.top + height - headerCellSize) / boxSize));

    var toRowLabel = typeof rowLabeler === 'function' ? rowLabeler : numberToLetter;
    return {
        startX: startX,
        startY: startY,
        endX: endX,
        endY: endY,
        rangeLabel: toRowLabel(startY) + (startX + 1) + ':' + toRowLabel(endY) + (endX + 1)
    };
}

module.exports = {
    numberToLetter: numberToLetter,
    letterToNumber: letterToNumber,
    getGridIndicesFromTopLeftUnclamped: getGridIndicesFromTopLeftUnclamped,
    SEAT_CELL_MARGIN: SEAT_CELL_MARGIN,
    FURNITURE_CELL_MARGIN: FURNITURE_CELL_MARGIN,
    clampGridPoint: clampGridPoint,
    getGridPointFromTopLeft: getGridPointFromTopLeft,
    getGridCellIndicesFromCenter: getGridCellIndicesFromCenter,
    computeSeatSnapPixels: computeSeatSnapPixels,
    computeFurnitureSnapLayout: computeFurnitureSnapLayout,
    getSeatGridPointFromObject: getSeatGridPointFromObject,
    seatGridPointResolverFromBrowser: seatGridPointResolverFromBrowser,
    getGridCellTopLeft: getGridCellTopLeft,
    getGridPositionStringFromPixelTopLeft: getGridPositionStringFromPixelTopLeft,
    getGridRangeFromObjectRect: getGridRangeFromObjectRect,
    pixelRectToGridRange: pixelRectToGridRange
};
